export default "__VITE_ASSET__6b1ba8f6__"